













import { Component, Vue, Prop } from 'vue-property-decorator';
import TagCheckBoxPicker from '@/components/registration/common/tags/TagCheckBoxPicker.vue';
import { TagSet } from '@/interfaces/registration/tags/TagSet';
import { TagSetModel } from '@/interfaces/registration/models/TagSetModel';

  @Component({
    components: { TagCheckBoxPicker }
  })
export default class TagSetCheckBoxPicker extends Vue {
    @Prop() readonly tagSet!: TagSet;
    @Prop({ default: () => { return {}; } }) readonly value!: TagSetModel;

    get model (): Array<number> {
      return this.value.tags;
    }

    get effectiveCount (): number {
      const idx = (this.$parent as any).visibleTagSets.findIndex(
        (ts: TagSet) => ts.id === this.tagSet.id
      );
      return (this.$parent as any).getNumberOfSelected(idx);
    }

    public addTags (tags: Array<number>): void {
      const newTags: Array<number> = [];
      tags.forEach((tag) => {
        if (this.model.indexOf(tag) === -1) {
          newTags.push(tag);
        }
      });

      this.$emit('input', { name: this.value.name, tags: [...this.model, ...newTags] });
    }

    public removeTags (tags: Array<number>): void {
      const newTags: Array<number> = this.model.filter((tag) => {
        return tags.indexOf(tag) === -1;
      });

      this.$emit('input', { name: this.value.name, tags: newTags });
    }
}
